import {
  ApolloClient,
  ApolloProvider,
  type NormalizedCacheObject,
  from,
} from '@apollo/client';
import type { ReactNode } from 'react';

import { createContextLink } from './createContextLink';
import { useErrorLink } from './useErrorLink';

interface ApolloProviderWrapperProps {
  apolloClient: ApolloClient<NormalizedCacheObject>;
  children: ReactNode;
  serverXRequestId?: string;
}

export const ApolloProviderWrapper = ({
  apolloClient,
  children,
  serverXRequestId,
}: ApolloProviderWrapperProps) => {
  const contextLink = createContextLink({ serverXRequestId });
  const errorLink = useErrorLink();

  // Create new Apollo client with error link
  const apolloClientWithLinks = new ApolloClient({
    ...apolloClient,
    link: from([contextLink, errorLink, apolloClient.link]),
  });

  return (
    <ApolloProvider client={apolloClientWithLinks}>{children}</ApolloProvider>
  );
};
